import React from 'react';
import RenderInBodyWithPortal from './RenderInBodyWithPortal';

const RenderInBody = ({ children, type }) => {
  return <RenderInBodyWithPortal>{children}</RenderInBodyWithPortal>;
};

export default RenderInBody;
